import { styled } from '@mui/material/styles'
import Autocomplete from '@mui/material/Autocomplete'

const StyledAutocomplete = styled(Autocomplete)(({ theme, value }) => ({
  '.MuiAutocomplete-input': {
    padding: '1.2rem 0rem !important',
  },
  '.MuiAutocomplete-inputRoot': {
    padding: 0,
    paddingLeft: '2rem',
    ...(Array.isArray(value) && value.length && { padding: '10px' }),
  },
  '.MuiAutocomplete-paper': {
    marginTop: '0.4rem',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.primary[200],
  },
  '.MuiAutocomplete-tag': {
    backgroundColor: theme.palette.primary[200],
    height: 26,
    position: 'relative',
    zIndex: 0,
    '& .MuiChip-label': {
      color: theme.palette.primary[600],
    },
    '& .MuiChip-deleteIcon': {
      color: theme.palette.primary[200],
      '&:hover': {
        color: theme.palette.primary[200],
      },
    },
    '&:after': {
      content: '""',
      right: 10,
      top: 6,
      height: 12,
      width: 12,
      position: 'absolute',
      backgroundColor: '#200E32',
      opacity: 0.4,
      zIndex: -1,
    },
  },
}))

export const ThemedAutocomplete = (props) => {
  return <StyledAutocomplete {...props} />
}
